import {MessageNotificationTriEnum} from "@resources/resources";

export class MessageNotificationTriEnums {

  private static _titre: MessageNotificationTriEnum = 'TITRE';
  private static _canal_nom: MessageNotificationTriEnum = 'CANAL_NOM';
  private static _date_publication: MessageNotificationTriEnum = 'DATE_PUPLICATION';
  private static _read: MessageNotificationTriEnum = 'READ';

  static TITRE = new MessageNotificationTriEnums(MessageNotificationTriEnums._titre);
  static CANAL_NOM = new MessageNotificationTriEnums(MessageNotificationTriEnums._canal_nom);
  static DATE_PUBLICATION = new MessageNotificationTriEnums(MessageNotificationTriEnums._date_publication);
  static READ = new MessageNotificationTriEnums(MessageNotificationTriEnums._read);

  private static _values = [MessageNotificationTriEnums.TITRE.value(), MessageNotificationTriEnums.CANAL_NOM.value(),
    MessageNotificationTriEnums.DATE_PUBLICATION.value(),
    MessageNotificationTriEnums.READ.value()];

  constructor(public str: MessageNotificationTriEnum) {
  }

  value(): MessageNotificationTriEnum {
    return this.str;
  }

  static values(): Array<MessageNotificationTriEnum> {
    return this._values;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-notifications/digicerba-notifications-web/src/angular/cerba/src/app/common/enum/messagenotificationtri.enum.ts